import React, {FC} from 'react'
import {RouteComponentProps} from 'react-router-dom'
import classnames from 'classnames'
import '../styles/page/introduceDoc.less'

const NewMachinePro: FC<RouteComponentProps> = props => {
  return (
    <div className={classnames('new_machine_pro_box')}>
      <div className={classnames('new_machine_pro')}>
        <h2 className={classnames('pt36')}>IP代理功能介绍</h2>
        <p className={classnames('pt24')}>简介：</p>
        <p className={classnames('pt12')}>IP代理服务，其功能就是代用户去取得网络信息，然后返回给用户。用户在访问目标站点时，可以隐藏用户的真实IP。<br />
          爱云兔群控所提供的代理IP均为爱云兔群控真实服务器机房的IP，购买后设备即可随机切换不同的IP。</p>
        <span className={classnames('c12', 'fs12', 'cFF4242')}>严正声明：任何使用该服务的用户请请严格遵循中华人民共和国法律法规行为，使用此服务造成的任何后果由使用者个人承担，必要情况下我司将竭力配合网监部门协助调查。</span>
        <h3 className={classnames('pt24')}>产品说明：</h3>
        <div>IP代理服务根据不同的业务场景区分不同的产品分类，用户可更加自身业务需要进行选择。</div>
        <span className={classnames('c888')}>备注：若遇到apk升级，请关闭IP代理服务后，在进行应用升级。</span>
        <div className={classnames('fs16', 'pt12')}>* 初级产品：适用于低带宽游戏及社交软件的场景；</div>
        <div className={classnames('fs16', 'pt8')}>* 中级产品：基本能满足非视频类应用的场景；</div>
        <div className={classnames('fs16', 'pt8')}>* 高级产品：适用于直播、短视频类对带宽需求较高的应用场景。</div>
        <h3 className={classnames('pt36')}>操作流程：</h3>
        <div className={classnames('pt24')}>1、状态：购买IP代理服务的设备会显示IP代理服务标签。</div>
        <img className={classnames('pt18')} src={require('../assets/pro/newIp.png')} alt=''/>
        <div className={classnames('pt38')}>2、设置：选择某一分组，点击【批量处理】中的【IP服务管理】</div>
        <img className={classnames('pt18')} src={require('../assets/qc-bg.png')} alt=''/>
        <div className={classnames('pt18')}>3、选择设备：只可对购买IP代理服务的设备进行操作</div>
        <img className={classnames('pt6')} src={require('../assets/pro/ipbackups.png')} alt=''/>
        <div className={classnames('pt18')}>开启：随机分配1个IP</div>
        <div className={classnames('pt8')}>关闭：恢复原始IP</div>
        <div className={classnames('pt8')}>切换：在开启状态下，再次随机1个IP</div>
        <span className={classnames('pt12')}>*注：IP池数量有限，在切换IP时，有可能切换成层使用过的IP</span>
        <div className={classnames('pt24')}>4.开启成功：选择设备并进行上一步操作后，显示下面状态。图二代表开启成功</div>
        <img className={classnames('pt38')} src={require('../assets/pro/IpOpenStatus.png')} alt=''/>
      </div>
    </div>
  )
}
export default NewMachinePro
